module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Lista sklepów', 'ShopList')))])]), _vm._v(" "), _c('form', {
    staticClass: "om-search flex sb",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "om-search__input fg-20",
    attrs: {
      "id": "search",
      "placeholder": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ShopList'),
      "title": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'ShopList')
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "om-btn om-search__submit",
    attrs: {
      "type": "submit",
      "placeholder": _vm.$tr('', 'ShopList')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tr('Szukaj', 'ShopList')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading flex sb"
  }, [(_vm.search != '') ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--bright"
  }, [_vm._v(_vm._s(_vm.$tr('Wyniki wyszukiwania:', 'ShopList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.search))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--num"
  }, [_vm._v("(" + _vm._s(_vm.filteredCount) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v("\n        " + _vm._s(_vm.$tr('Pokaż', 'ShopList')) + "\n      ")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.itemsPerPage,
      "default-label": _vm.defaultPerPage.name,
      "default-value": _vm.defaultPerPage.value
    },
    on: {
      "change": _vm.changePerPage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex wrap"
  }, [_c('label', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.$tr('Wyświetl:', 'ShopList')))]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "items": _vm.displayOptions,
      "default-label": _vm.displayOptionCurrent ? _vm.displayOptionCurrent.name : null,
      "default-value": _vm.displayOptionCurrent ? _vm.displayOptionCurrent.value : null
    },
    on: {
      "change": _vm.sortBy
    }
  })], 1)]), _vm._v(" "), (_vm.pageContent.length) ? _c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.columns.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.code))]), _vm._v(" "), _c('th', {
    staticClass: "td--cen"
  }, [_vm._v(_vm._s(_vm.columns.orders))]), _vm._v(" "), _c('th', {
    staticClass: "td--cen"
  }, [_vm._v(_vm._s(_vm.columns.settings))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageContent), function(item) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "font-normal"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', [_vm._v("\n            " + _vm._s(_vm.$tr('ul.', 'ShopList')) + " " + _vm._s(item.address.street) + "\n            " + _vm._s(item.address.house) + "\n            " + _vm._s(typeof item.address.flat !== 'undefined' && item.address.flat !== '' ? ("/ " + (item.address.flat)) : '') + "\n          ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.address.postcode) + " " + _vm._s(item.address.city))])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(item.code) + "\n        ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "flex sb"
    }, [_c('button', {
      staticClass: "om-btn om-btn--check",
      class: [item.can_return ? 'is-active' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.can_return = !item.can_return;
          _vm.updateShop(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$tr('Zwrot', 'ShopList')) + "\n            ")]), _vm._v(" "), _c('button', {
      staticClass: "om-btn om-btn--check",
      class: [item.can_collect ? 'is-active' : ''],
      on: {
        "click": function($event) {
          $event.preventDefault();
          item.can_collect = !item.can_collect;
          _vm.updateShop(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.$tr('Odbiór', 'ShopList')) + "\n            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "more td--cen"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ShopSettings',
          params: {
            code: item.code
          }
        }
      }
    }, [_c('i', {
      staticClass: "om-ico-tools",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0)]) : _c('div', [_vm._v(_vm._s(_vm.$tr('Brak wyników wyszukiwania', 'ShopList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-footer flex sb"
  }, [_c('div', {
    staticClass: "om-add-shop"
  }, [_c('router-link', {
    staticClass: "om-btn--add-shop",
    attrs: {
      "to": {
        name: 'ShopSettings',
        params: {
          code: 'new'
        }
      },
      "tag": "button",
      "id": "cta-add-new-shop"
    }
  }, [_c('div', {
    staticClass: "om-btn__upper-txt"
  }, [_vm._v(_vm._s(_vm.$tr('Dodaj nowy sklep', 'ShopList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-btn__lower-txt"
  }, [_vm._v(_vm._s(_vm.$tr('Utwórz konto dla nowego sklepu', 'ShopList')))])])], 1), _vm._v(" "), _c('paginator', {
    attrs: {
      "items-per-page": _vm.currentPerPage,
      "passive-mode": _vm.paginatorPassive,
      "request": _vm.request,
      "update-force": _vm.requestUpdateForce
    },
    on: {
      "change": _vm.updatePageContent
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed05c3ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ShopList.vue
// module id = 286
// module chunks = 1